export default __webpack_public_path__ + "static/media/EG_Mix-2.bff23e4e.wav";